import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'enlighterjs/dist/enlighterjs.min.css';
import './assets/css/style.css';
import './assets/css/animate.min.css';
import './assets/css/owl.carousel.min.css';
import './assets/css/main.css';

import { Home, About, Blog, Contact, Resume, Certifications } from './pages';
import BlogDetails from './pages/blog/BlogDetails';
import Categories from './pages/blog/Categories';
import Tags from './pages/blog/Tags';
import Header from './components/Header';
import Footer from './components/Footer';
import Preloader from './components/Preloader';

import useAuthToken from './hooks/useAuthToken';
import useClientIp from './hooks/useClientIp';
import useSiteSettings from './hooks/useSiteSettings';

const App = () => {
  	const { token } = useAuthToken();
  	useClientIp();
  	useSiteSettings( token );

  	return (
    	<Router>
      		<Preloader />
			<div id="main-wrapper">
				<Header />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about-me" element={<About />} />
					<Route path="/blog" element={<Blog />} />
					<Route path="/resume" element={<Resume />} />
					<Route path="/certifications" element={<Certifications />} />
					<Route path="/connect-me" element={<Contact />} />
					<Route path="/blog/:slug" element={<BlogDetails />} />
					<Route path="/category/:slug" element={<Categories />} />
					<Route path="/tag/:slug" element={<Tags />} />
				</Routes>
				<Footer />
			</div>
    	</Router>
  	);
};

export default App;